import { create } from 'zustand';
import { UIState } from '../types';

const getDefaultSidebarOpen = (): boolean => {
  if (typeof window === 'undefined') return true;
  return window.innerWidth >= 1024;
};

const getDefaultSidebarMode = (): UIState['sidebarMode'] => {
  if (typeof window === 'undefined') return 'persistent';
  if (window.innerWidth >= 1024) return 'persistent';
  if (window.innerWidth >= 640) return 'overlay';
  return 'fullscreen';
};

export const useUIStore = create<UIState>()((set) => ({
  sidebarOpen: getDefaultSidebarOpen(),
  sidebarMode: getDefaultSidebarMode(),

  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),

  setSidebarOpen: (open: boolean) => set({ sidebarOpen: open }),

  setSidebarMode: (mode: UIState['sidebarMode']) => set({ sidebarMode: mode }),
}));
